import { InitOptions } from 'i18next'

// already mapped to { reference: content } by scripts/update-cms-cache.ts
import enPhrases from '../cache/phrases/en.json'

export const Options: InitOptions = {
  compatibilityJSON: 'v4',
  fallbackLng: process.env.STORYBOOK ? 'no-translation' : 'en',
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: { translation: enPhrases as Record<string, string> },
  },
  react: {
    useSuspense: false,
    bindI18n: 'loaded languageChanged',
    bindI18nStore: 'added',
  },
}
